import { WSSelect } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { generatePath, useHistory, useLocation } from "react-router-dom";
import { useIsTaxDocumentsExist } from "../../utils/useIsTaxDocumentsExist";
import { TAX_DOCUMENTS_PATH } from "../../paths";
import { OLD_TAX_DOCUMENTS_PATH } from "../../../TaxDocumentsOld/paths";
import {
  getTaxYears,
  OLD_TAX_YEAR
} from "../../../../shared/constants/taxYear";

type Props = {};

export const SelectTaxYear: React.FC<Props> = ({}) => {
  const location = useLocation();
  const history = useHistory();
  const showOldTaxDocuments = useIsTaxDocumentsExist(OLD_TAX_YEAR);

  const options = useMemo(() => {
    return [
      ...getTaxYears().map(year => ({
        value: `${year}`,
        label: `${year}`,
        path: generatePath(TAX_DOCUMENTS_PATH, { year })
      })),
      {
        value: `${OLD_TAX_YEAR}`,
        label: `${OLD_TAX_YEAR}`,
        path: OLD_TAX_DOCUMENTS_PATH
      }
    ].filter(p => (showOldTaxDocuments ? true : p.value !== `${OLD_TAX_YEAR}`));
  }, [showOldTaxDocuments]);

  const currentOption = options.find(p => location.pathname.startsWith(p.path));

  const defaultValue = currentOption?.value || options[0].value;

  return (
    <WSSelect
      hideClearAction={true}
      mode="single"
      value={defaultValue}
      onChange={newValue => {
        const newPath = options.find(p => p.value === newValue)?.path;

        if (newPath) {
          history.push(newPath);
        }
      }}
      options={options}
    />
  );
};
